<!-- Fixed h-14 (not py-3.5) so the bar keeps the same height whether or not the
     account-blocked message - which is taller than the title - is showing. -->
<div class="flex justify-between items-center pl-5 pr-3 h-14 border-b border-surface-200 shrink-0"
     [class.bg-gray-50]="!templateMode()"
     [class.template-tint]="templateMode()">
  <div class="flex gap-2 items-center shrink-0">
    <i [class]="iconClass()"></i>
    <div class="text-surface-900 text-xl font-semibold font-['Inter'] leading-7">
      {{ !!screenTitle() ? screenTitle() : 'Travel Allowance Platform' }}
    </div>
    <!-- Autosave indicator: shown while the save queue is draining, on the pages that opted in. -->
    @if (showSaving()) {
      <div class="text-surface-400 text-sm" data-testid="save-status">Saving...</div>
    }
  </div>

  <!-- The icon and "Account Blocked" never truncate; the detail text ellipses away as the window
       narrows. account-blocked-message unlocks min-width on PrimeNG's Message internals - see
       assets/styles.css - without which the whole bar just gets wider. -->
  @if (accountBlocked()) {
    <p-message severity="warn" size="small" class="account-blocked-message min-w-0 mx-4" data-testid="account-blocked-message">
      <div class="flex gap-2 items-center min-w-0">
        <i class="fa-light fa-warning shrink-0"></i>
        <span class="text-sm font-medium font-['Inter'] shrink-0">Account Blocked</span>
        <span class="text-xs font-medium font-['Inter'] text-surface-700 truncate min-w-0"
              [title]="blockedMessage()">{{ blockedMessage() }}</span>
      </div>
    </p-message>
  }

  @if (templateMode()) {
    <!-- The box is PrimeNG's inner .p-message, shadowed via its theme token rather than the host. -->
    <p-message severity="warn" size="small" class="min-w-0 mx-4 [--p-message-warn-shadow:0px_4px_6px_-1px_rgba(0,0,0,0.05),0px_2px_4px_-2px_rgba(0,0,0,0.05)]" data-testid="template-warning">
      <div class="flex gap-2 items-center min-w-0">
        <i class="fa-light fa-warning shrink-0"></i>
        <span class="text-sm font-medium font-['Inter']">Important: You are viewing/editing a Template, not a TA</span>
      </div>
    </p-message>
  }

  @if (showTaComments()) {
    <div class="pr-4">
      <ta-comments [taId]="taSubmissionId()" [capabilities]="taCommentCapabilities()" mode="collapsible"></ta-comments>
    </div>
  }

  @if (breadTrail().length > 0) {
    <div class="text-surface-400 text-sm flex gap-3 items-center shrink-0 pr-4">
      {{breadTrail()}}
    </div>
  }
</div>
